import React from "react";
import Footer5 from "../Footer5";
import "./Footer4.css";

function Footer4() {
  return (
    <div className="footer-7">
      <Footer5 />
    </div>
  );
}

export default Footer4;
